import {ParsedUrlQuery} from 'querystring';

type TQuery = ParsedUrlQuery | Record<string, unknown> | undefined;

export const getTabIdFromUrl = (url?: string, query?: TQuery): string | undefined => {
    const search = url?.split('?')[1];

    if (search) {
        const params = new URLSearchParams(search);
        const tabIdFromSearch = params.get('tabId');

        if (tabIdFromSearch) {
            return tabIdFromSearch;
        }
    }

    const tabIdFromQuery = (query as Record<string, unknown> | undefined)?.tabId;

    if (!tabIdFromQuery) {
        return undefined;
    }

    if (Array.isArray(tabIdFromQuery)) {
        return tabIdFromQuery[0] as string;
    }

    return tabIdFromQuery as string;
};
